import CrossStorageClass from '@/shared/js/services/CrossAuth'

const BACKEND_URL = process.env.VUE_APP_CROSS_STORAGE_URL

const CrossAuth = new CrossStorageClass(`${BACKEND_URL}cross-auth`)

export { CrossAuth }
